import { Children } from 'react';
import { PropTypes } from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { get } from 'utils/lodash';

import Icon from 'components/common/Icon';

import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';

const PasswordChecklist = ({ validators, title, newPassword }) => (
  <>
    <div className="ph3">
      <Typography variant="subtitle1">{title}</Typography>
    </div>
    <List dense>
      {Children.toArray(
        validators.map(validator => {
          const message = get(validator, 'message', '');
          const isValid = get(validator, 'isValid', false);
          const hasValidation = get(validator, 'hasValidation', false);
          const iconClass = (!isEmpty(newPassword) && (isValid ? 'check' : 'close')) || 'dot';
          const colorClass = (!isEmpty(newPassword) && (isValid ? 'green' : 'red')) || 'black dot';

          return (
            <ListItem>
              {hasValidation ? (
                <>
                  <ListItemIcon>
                    <Icon type={iconClass} className={colorClass} />
                  </ListItemIcon>

                  <ListItemText className={colorClass}>{message}</ListItemText>
                </>
              ) : (
                <ListItemText>
                  <strong>{message}</strong>
                </ListItemText>
              )}
            </ListItem>
          );
        })
      )}
    </List>
  </>
);

PasswordChecklist.propTypes = {
  title: PropTypes.string.isRequired,
  validators: PropTypes.array.isRequired,
  newPassword: PropTypes.string.isRequired,
};

export default PasswordChecklist;
